import { request } from "../client";

import type {
  StripeCheckoutSessionRequest,
  StripeCheckoutSessionResponse,
  StripePortalSessionResponse,
  StripeCurrentResponse,
  StripeChangePlanRequest,
  StripeGenericResponse,
} from "../types/stripe";

export function createStripeEndpoints(baseUrl: string): {
  createCheckoutSession: (
    payload: StripeCheckoutSessionRequest,
    token?: string | null,
  ) => Promise<StripeCheckoutSessionResponse>;
  createPortalSession: (
    token?: string | null,
  ) => Promise<StripePortalSessionResponse>;
  getCurrent: (token?: string | null) => Promise<StripeCurrentResponse>;
  changePlan: (
    payload: StripeChangePlanRequest,
    token?: string | null,
  ) => Promise<StripeGenericResponse>;
  reactivate: (token?: string | null) => Promise<StripeGenericResponse>;
} {
  return {
    createCheckoutSession(
      payload: StripeCheckoutSessionRequest,
      token?: string | null,
    ): Promise<StripeCheckoutSessionResponse> {
      return request<StripeCheckoutSessionResponse>(
        baseUrl,
        "/stripe/create-checkout-session",
        {
          method: "POST",
          body: payload,
          token,
        },
      );
    },
    createPortalSession(
      token?: string | null,
    ): Promise<StripePortalSessionResponse> {
      return request<StripePortalSessionResponse>(
        baseUrl,
        "/stripe/create-portal-session",
        {
          method: "POST",
          body: {},
          token,
        },
      );
    },
    getCurrent(token?: string | null): Promise<StripeCurrentResponse> {
      return request<StripeCurrentResponse>(baseUrl, "/stripe/current", {
        method: "GET",
        token,
      });
    },
    changePlan(
      payload: StripeChangePlanRequest,
      token?: string | null,
    ): Promise<StripeGenericResponse> {
      return request<StripeGenericResponse>(baseUrl, "/stripe/change-plan", {
        method: "POST",
        body: payload,
        token,
      });
    },
    reactivate(token?: string | null): Promise<StripeGenericResponse> {
      return request<StripeGenericResponse>(baseUrl, "/stripe/reactivate", {
        method: "POST",
        body: {},
        token,
      });
    },
  };
}
